(function () {
	'use strict';

	var module = angular.module('uwAgenda.users');
	module.directive('ibanNumberValidation', ['HelperService', IbanNumberValidationFn]);

	function IbanNumberValidationFn(HelperService) {

		var directive = {
			require: 'ngModel',
			restrict: 'A',
			scope: {
				
			},
			link: link
		};
		return directive;

		function link(scope, element, attrs, ctrl) {
		
			ctrl.$validators.ibanNumberValid = function (value) {
				if (!value) {
					return  true;
				}

				return HelperService.validateIbanNumber(value);
			};		
		}
	}
})();